<template>
  <vs-card>
    <vs-tabs v-model="activeTab" position="top" alignment="fixed">
      <vs-tab label="Organization Details">
        <ShowGuideTutorial module="organization-details" />
        <div class="vx-row px-5">
          <div class="vx-col w-full px-8">
            <form method="POST">
              <h3 class="text-xl w-full font-bold my-5">Basic Details</h3>
              <div class="vx-row">
                <!-- Organization Name -->
                <div class="vx-col w-1/2 mb-8">
                  <vs-input class="w-full" v-validate="'required|exclude_special_char'" v-model="form.name"
                    label="Organization Name *" placeholder="Ex. All-India Sikh Students Federation (AISSF)"
                    name="Organization Name" id="Organization Name" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('Organization Name')">{{
                    errors.first('Organization Name') }}</span>
                </div>

                <!-- Country -->
                <div class="vx-col w-1/6 mb-8">
                  <label class="vs-input--label">Country *</label>
                  <select-2 class="w-full country-input" name="country" placeholder=" Select Country"
                    :value="form.country" @input="(item) => (form.country = item && item.value)" autocomplete
                    :ssr="true" :multiple="false" v-model="form.country" v-validate="'required'"
                    action="common/getCountries" :viewRendered="false" :options="CountryList" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('country')">{{ errors.first('country') }}</span>
                </div>

                <!-- State -->
                <div class="vx-col w-1/6 mb-8">
                  <label class="vs-input--label">State *</label>
                  <select-2 class="w-full" name="State" placeholder="Select State" :value="form.state"
                    v-model="form.state" @input="(item) => (form.state = item && item.value)" :options="StateList"
                    :viewRendered="false" autocomplete :ssr="true" :multiple="false" v-validate="'required'"
                    action="common/getStates" :params="{ country: form.country }" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('State')">{{ errors.first('State') }}</span>
                </div>

                <!-- City -->
                <div class="vx-col w-1/6 mb-8">
                  <label class="vs-input--label">City *</label>
                  <select-2 class="w-full" name="City" placeholder="Select City" :value="form.city" v-model="form.city"
                    @input="(item) => (form.city = item && item.value)" :options="CityList" autocomplete :ssr="true"
                    :viewRendered="false" :multiple="false" v-validate="'required'" action="common/getCities"
                    :params="{ state: form.state, country: form.country }" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('City')">{{ errors.first('City') }}</span>
                </div>

                <!-- Website -->
                <div class="vx-col w-1/3 mb-8">
                  <vs-input icon-pack="feather" icon="icon icon-globe" class="w-full"
                    v-validate="'exclude_special_char|url'" v-model="form.website" label="Website"
                    placeholder="www.google.com" name="Website" id="Website" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('Website')">{{ errors.first('Website') }}</span>
                </div>
                <!-- Email -->
                <div class="vx-col w-1/3 mb-8">
                  <vs-input class="w-full" icon-pack="feather" icon="icon icon-mail" v-validate="'email'"
                    v-model="form.email" label="Email" placeholder="abc@gmail.com" name="Email" id="Email"
                    :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
                </div>
                <!-- Phone No -->
                <div class="vx-col w-1/3 mb-8">
                  <label class="vs-input--label">Mobile Number</label>
                  <vue-tel-input :key="isUpdate" v-model="form.mobile_number" class="w-full vs-inputx vs-input--input"
                    name="mobile_number" data-vv-as="Mobile Number" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-if="errors['mobile_number']">
                    {{ errors['mobile_number'] }}
                  </span>
                  <span class="text-danger text-sm" v-show="errors.has('mobile_number')">{{
                    errors.first('mobile_number') }}</span>
                </div>

                <!-- Location Link -->
                <div class="vx-col w-1/2 mb-8">
                  <vs-input icon="icon icon-map-pin" icon-pack="feather" class="w-full"
                    v-validate="'required|exclude_special_char|url'" v-model="form.location_link"
                    label="Location Link *" placeholder=" https://goo.gl/maps/2X1tD5XJ1xC2" name="Location Link"
                    id="Location Link" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('Location Link')">{{ errors.first('Location Link') }}</span>
                </div>

                <div class="vx-col w-full mt-4">
                  <vs-textarea cols="3" rows="5" icon-pack="feather" class="w-full mb-0"
                    v-validate="'required|exclude_special_char'" v-model="form.address" label="Address *" name="Address"
                    id="Address" style="border: 2px solid #eeeeee" :disabled="!isEditable">
                  </vs-textarea>
                  <span class="text-danger text-sm" v-show="errors.has('Address')">{{ errors.first('Address') }}</span>
                </div>

                <vs-divider></vs-divider>

                <!-- Gurudwara Images -->
                <h3 class="text-xl w-full font-bold my-5 ml-4">Organization Images</h3>
                <div class="vx-col w-full" v-if="isEditable">
                  <label class="vs-input--label block"> Images * </label>
                  <p class="text-base">Select up to 20 images, each under 1 MB, in JPG, PNG, or JPEG format</p>
                  <input :key="fileKey" type="file" class="rounded w-full text-lg file-upload" id="Gurudwara image"
                    ref="files" accept=".jpg, .png , .jpeg" @change="handleFileUpload" multiple />
                  <input type="hidden" name="Gurudwara image" v-model="form.organization_image"
                    v-validate="validationRules()" data-vv-as="Image" />
                  <span class="text-danger text-sm" v-show="errors.has('Gurudwara image')">{{ errors.first('Gurudwara image') }}</span>
                </div>
                <div class="vx-col w-1/2 mb-8"></div>
                <div class="vx-col w-full">
                  <div class="mt-5 flex items-center flex-wrap gap-5">
                    <div v-for="(image, index) in form.exist_organization_image" :key="index" class="relative group"
                      style="width: 20rem !important; height: 20rem !important">
                      <div class="overflow-hidden mb-8">
                        <img :src="image" alt="Image Preview"
                          style="width: 20rem !important; height: 20rem !important" />
                        <div class="absolute top-0 right-0" v-if="isEditable">
                          <vx-tooltip :text="`Remove`" class="cursor-pointer">
                            <div class="text-xl w-12 h-12 flex justify-center items-center rounded-lg m-2"
                              @click="removeFile(image, 'edit')">&#x2715;</div>
                          </vx-tooltip>
                        </div>
                      </div>
                    </div>
                    <div v-for="(image, index) in preview_images" :key="index" class="relative group"
                      style="width: 20rem !important; height: 20rem !important">
                      <div class="overflow-hidden mb-8">
                        <img :src="image.src" alt="Image Preview"
                          style="width: 20rem !important; height: 20rem !important" />
                        <div class="absolute top-0 right-0">
                          <vx-tooltip :text="`Remove`" class="cursor-pointer">
                            <div class="text-xl w-12 h-12 flex justify-center items-center rounded-lg m-2"
                              @click="removeFile(index, 'preview')">&#x2715;</div>
                          </vx-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <vs-divider></vs-divider>

              <!-- Organization Videos -->
              <h3 class="text-xl w-full font-bold my-5 ml-4">Organization Videos</h3>
              <div class="vx-col w-full" v-if="isEditable">
                <label class="vs-input--label block"> Videos </label>
                <p class="text-base">Select up to 20 videos, each under 60 seconds, in any format</p>
                <input :key="'video-' + fileKey" type="file" class="rounded w-full text-lg file-upload"
                  id="Organization video" ref="videoFiles" accept="video/*" @change="handleVideoUpload" multiple />
              </div>
              <div class="vx-col w-1/2 mb-8"></div>
              <div class="vx-col w-full mb-20">
                <div class="mt-5 flex items-center flex-wrap gap-5">
                  <div v-for="(video, index) in form.exist_organization_video" :key="'exist-video-' + index"
                    class="relative group" style="width: 20rem !important; height: 20rem !important">
                    <div class="overflow-hidden rounded-lg h-full">
                      <video :src="video" class="w-full h-full object-cover" controls></video>
                      <div class="absolute top-0 right-0" v-if="isEditable">
                        <vx-tooltip :text="`Remove`" class="cursor-pointer">
                          <div style="background-color: var(--neutral); color: var(--neutral-invert);"
                            class="text-xl w-12 h-12 flex justify-center items-center rounded-lg m-2"
                            @click="removeVideo(video, 'edit')">&#x2715;</div>
                        </vx-tooltip>
                      </div>
                    </div>
                  </div>
                  <div v-for="(video, index) in preview_videos" :key="'preview-video-' + index" class="relative group"
                    style="width: 20rem !important; height: 20rem !important">
                    <div class="overflow-hidden rounded-lg h-full">
                      <video :src="video.src" class="w-full h-full object-cover" controls></video>
                      <div class="absolute top-0 right-0">
                        <vx-tooltip :text="`Remove`" class="cursor-pointer">
                          <div style="background-color: var(--neutral); color: var(--neutral-invert);"
                            class="text-xl w-12 h-12 flex justify-center items-center rounded-lg m-2"
                            @click="removeVideo(index, 'preview')">&#x2715;</div>
                        </vx-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <vs-divider></vs-divider>

              <!-- Social Media Links Section -->
              <div class="vx-col w-full mb-4">
                <h3 class="text-xl font-bold my-10">Social Media Links</h3>
                <div class="vx-row mt-4">
                  <!-- Facebook -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" v-model="form.social_media.facebook" label="Facebook"
                      placeholder="https://www.facebook.com/YourPage" name="Facebook" id="Facebook"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('Facebook')">{{ errors.first('Facebook')
                      }}</span>
                  </div>
                  <!-- Instagram -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" v-model="form.social_media.instagram" label="Instagram"
                      placeholder="https://www.instagram.com/YourProfile" name="Instagram" id="Instagram"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('Instagram')">{{ errors.first('Instagram')
                      }}</span>
                  </div>
                  <!-- Twitter -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" v-model="form.social_media.twitter" label="Twitter"
                      placeholder="https://www.twitter.com/YourProfile" name="Twitter" id="Twitter"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('Twitter')">{{ errors.first('Twitter')
                      }}</span>
                  </div>
                  <!-- Snapchat -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" v-model="form.social_media.snapchat" label="Snapchat"
                      placeholder="https://www.snapchat.com/YourProfile" name="Snapchat" id="Snapchat"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('Snapchat')">{{ errors.first('Snapchat')
                      }}</span>
                  </div>
                  <!-- TikTok -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" v-model="form.social_media.tiktok" label="TikTok"
                      placeholder="https://www.tiktok.com/@YourProfile" name="TikTok" id="TikTok"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('TikTok')">{{ errors.first('TikTok') }}</span>
                  </div>
                  <!-- LinkedIn -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" v-model="form.social_media.linkedin" label="LinkedIn"
                      placeholder="https://www.linkedin.com/in/YourProfile" name="LinkedIn" id="LinkedIn"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('LinkedIn')">{{ errors.first('LinkedIn')
                      }}</span>
                  </div>
                  <!-- YouTube -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" v-model="form.social_media.youtube" label="YouTube"
                      placeholder="https://www.youtube.com/c/YourChannel" name="YouTube" id="YouTube"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('YouTube')">{{ errors.first('YouTube')
                      }}</span>
                  </div>
                </div>
              </div>
              <vs-divider></vs-divider>
              <!-- Other Links Fields Section -->
              <div class="w-full mb-4">
                <div class="flex justify-between my-5">
                  <div class="flex items-center">
                    <h3 class="text-xl font-bold">Other Links</h3>
                  </div>
                  <vs-button @click="addOtherLink()" class="mb-4 color" size="default" v-if="isEditable"> Add Other
                    Name</vs-button>
                </div>
                <!-- <div class="flex justify-between items-center mb-8">
                  <h4 class="text-lg font-semibold">Other Links</h4>
                  <vx-tooltip :text="`Add Other Links`">
                    <vs-button color="success" type="gradient" icon-pack="feather" icon="icon-plus" />
                  </vx-tooltip>
                </div> -->
                <div v-for="(otherLink, index) in form.custom_link" :key="index"
                  class="other-link-entry w-full flex flex-wrap mb-8">
                  <div class="vx-col w-full md:w-1/2 px-2 mb-8">
                    <vs-input v-model="otherLink.title" label="Title *" :name="'other_link_title_' + index"
                      v-validate="'required|exclude_special_char'" data-vv-as="Title" placeholder="Enter title"
                      class="w-full" :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has(`other_link_title_${index}`)">{{
                      errors.first(`other_link_title_${index}`) }}</span>
                  </div>
                  <div class="vx-col w-full md:w-1/2 px-2 mb-8">
                    <div class="flex items-center">
                      <vs-input v-model="otherLink.link" label="Link *" :name="'other_link_link_' + index"
                        v-validate="'required|exclude_special_char'" data-vv-as="Other Link" placeholder="Enter link"
                        class="w-full" :disabled="!isEditable" />
                      <vx-tooltip :text="`Remove Other Link`" class="ml-2 mt-6">
                        <vs-button @click="removeOtherLink(index)" color="danger" type="gradient" icon-pack="feather"
                          icon="icon-trash-2" />
                      </vx-tooltip>
                    </div>
                    <span class="text-danger text-sm" v-show="errors.has(`other_link_link_${index}`)">{{
                      errors.first(`other_link_link_${index}`) }}</span>
                  </div>
                </div>
              </div>

              <vs-divider></vs-divider>
              <div class="vx-col w-full mb-8">
                <!-- Add Other Name -->
                <div class="flex justify-between my-5">
                  <div class="flex items-center">
                    <h3 class="text-xl font-bold">Other Names</h3>
                  </div>
                  <vs-button @click="addData('other_name')" class="mb-4 color" size="default" v-if="isEditable"> Add
                    Other Name</vs-button>
                </div>
                <div class="other_name-container vx-row">
                  <div v-for="(record_value, index) in form.other_name" :key="index"
                    class="other-name-entry flex border-sky-500 border vx-col w-1/3">
                    <!-- Other Name -->
                    <div class="w-full mb-8">
                      <vs-input icon-pack="feather" type="text" v-validate="'required|exclude_special_char'"
                        data-vv-as="Other Name" v-model="form.other_name[index]" label="Other Name" placeholder=" AISSF"
                        :name="'other_name_' + index" class="w-full" :disabled="!isEditable" />
                      <span class="text-danger text-sm" v-show="errors.has(`other_name_${index}`)">{{
                        errors.first(`other_name_${index}`) }}</span>
                    </div>
                    <!-- Remove Other Name -->
                    <div class="w-1/12 flex items-center ml-1" v-if="isEditable">
                      <vx-tooltip :text="`Remove`">
                        <vs-button @click="removeData('other_name', index)" color="danger" type="gradient"
                          icon-pack="feather" icon="icon-trash-2" />
                      </vx-tooltip>
                    </div>
                  </div>
                </div>
              </div>

              <vs-divider></vs-divider>
              <!-- Youtube Handle Name -->
              <div class="vx-col w-full mb-8">
                <div class="flex justify-between my-5">
                  <div class="flex items-center">
                    <h3 class="text-xl font-bold">Youtube Handle Names</h3>
                  </div>
                  <vs-button @click="addData('youtube_handle_name')" class="mb-4 color" size="default"
                    v-if="isEditable">Add Handle Name</vs-button>
                </div>

                <div class="youtube_handle_name-container vx-row">
                  <div v-for="(record_value, index) in form.youtube_handle_name" :key="index"
                    class="other-name-entry flex border-sky-500 border vx-col w-1/3">
                    <div class="w-full mb-8">
                      <vs-input icon-pack="feather" type="text" v-validate="'required|exclude_special_char'"
                        data-vv-as="Youtube Handle Name" v-model="form.youtube_handle_name[index]"
                        label="Youtube Handle Name" placeholder="AISSFOfficial" :name="'youtube_handle_name_' + index"
                        class="w-full" :disabled="!isEditable" />
                      <span class="text-danger text-sm" v-show="errors.has(`youtube_handle_name_${index}`)">{{
                        errors.first(`youtube_handle_name_${index}`) }}</span>
                    </div>
                    <div class="w-1/12 flex items-center ml-1" v-if="isEditable">
                      <vx-tooltip :text="`Remove`">
                        <vs-button @click="removeData('youtube_handle_name', index)" color="danger" type="gradient"
                          icon-pack="feather" icon="icon-trash-2" />
                      </vx-tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <vs-divider></vs-divider>

              <!-- Save & Reset Button -->
              <div class="vx-row pt-5 px-5 text-center">
                <div class="vx-col w-full">
                  <div class="items-center">
                    <vs-button class="mr-2 w-64 vs-con-loading__container color" id="create-gurudwara" color="success"
                      @click="save_changes" v-if="isEditable"> Save & Next </vs-button>
                    <!-- <vs-button class="mr-2 vs-con-loading__container color" id="create-gurudwara" @click="nextTab" > Next</vs-button> -->
                    <!-- <vs-button color="danger" class="text-left" @click="navigateToGurudwaraList">Cancel</vs-button> -->
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Update" :disabled="disabledTab"
        v-if="checkPermissionSlug(['organization_update_create', 'organization_update_view'])">
        <UpdateList />
      </vs-tab>
      <vs-tab label="Member" :disabled="disabledTab">
        <MembersList />
      </vs-tab>
      <vs-tab label="Donation" :disabled="disabledTab"
        v-if="checkPermissionSlug(['organization_donation_create', 'organization_donation_edit', 'organization_donation_view', 'organization_donation_list'])">
        <DonationList />
      </vs-tab>
      <vs-tab label="Contact Us" :disabled="disabledTab"
        v-if="checkPermissionSlug(['organization_contact_create', 'organization_contact_edit', 'organization_contact_view'])">
        <ShowGuideTutorial module="contact-us" />
        <ContactList />
      </vs-tab>
      <vs-tab label="Thumbnail Manage" :disabled="disabledTab"
        v-if="checkRolesByIds(['admin', 'support_administrator'])">
        <ShowGuideTutorial module="organization-thumbnail" />
        <GraphichManage />
      </vs-tab>
      <vs-tab label="Service List" :disabled="disabledTab"
        v-if="checkPermissionSlug(['available_service_list', 'available_service_create', 'available_service_edit', 'available_service_view'])">
        <ShowGuideTutorial module="organization-service" />
        <ServiceList />
      </vs-tab>
      <vs-tab label="FAQs" :disabled="disabledTab" v-if="checkPermissionSlug(['faq_create', 'faq_edit', 'faq_view'])">
        <ShowGuideTutorial module="faqs" />
        <FaqList />
      </vs-tab>
      <vs-tab label="Tabs" :disabled="disabledTab" v-if="checkRolesByIds(['admin', 'support_administrator'])">
        <TabManage />
      </vs-tab>
    </vs-tabs>
    <vs-popup title="Image Editor" name="Image" :active.sync="IsOpenImageCrop"
      class="image-cropper gurudwara-edit-cropper" style="z-index: 55000; overflow: hidden">
      <div class="text-center flex justify-center modal-content-body w-full h-full overflow-y">
        <!-- modal content -->
        <div class="modal__content w-full h-full">
          <!-- modal body -->
          <div class="modal-body w-full h-full">
            <div class="modal-form w-full h-full">
              <div v-for="(cropImage, index) in this.crop_image" :key="index" class="cropper-container">
                <div class="w-full h-full max-h-450 py-5">
                  <cropper ref="cropper" :name="'Image' + index" class="cropper-image" :src="cropImage.src"
                    :stencil-props="{ aspectRatio: 12 / 12 }" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- modal content ends -->
      </div>
      <div class="button-wrapper modal-footer bottom-20 text-center p-0" style="border-top: 1px solid #dddddd">
        <vs-button type="" @click="cropImage()" class="text-white bg-black mt-5 mb-5 hover:shadow-lg">Save &
          Upload</vs-button>
      </div>
    </vs-popup>
  </vs-card>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { mapActions, mapState, mapGetters } from 'vuex'
import FaqList from './faq/list'
import ContactList from './contact/list'
import UpdateList from './update'
import MembersList from './member/list.vue'
import DonationList from './donation/list'
import ServiceList from './service'
import GraphichManage from './graphics/action'
import TabManage from './tab/action'
import ShowGuideTutorial from './show-guide-tutorial'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { dateMixins } from '@/mixins/dateMixins.js'
import moment from 'moment'
import { GURUDWARA_MAX_IMAGES_COUNT, MAX_IMAGE_SIZE, GURUDWARA_MAX_VIDEOS_COUNT, MAX_VIDEO_DURATION } from '../../utils/predefineTypes.js/constant'

export default {
  /** Page Name */
  name: 'AddUpdate',

  mixins: [dateMixins],

  /** components */
  components: {
    Select2,
    Cropper,
    FaqList,
    ContactList,
    DonationList,
    GraphichManage,
    ServiceList,
    flatPickr,
    ShowGuideTutorial,
    UpdateList,
    MembersList,
    TabManage
  },

  /** data */
  data() {
    return {
      fileKey: 0,
      lastModifiedDay: null,
      isUpdate: false,
      disabledTab: true,
      activeTab: 0,
      countryID: null,
      stateID: null,
      cityID: null,
      StateList: [],
      CountryList: [],
      CityList: [],
      BEST_WEATHR_TO_VISIT_LIST: [],
      BEST_TIME_TO_VISIT_LIST: [],
      breadcrumb: [],
      form: {
        custom_link: [],
        name: null,
        location_link: null,
        country: null,
        address: null,
        website: null,
        mobile_number: '',
        email: null,
        state: null,
        city: null,
        other_name: [],
        youtube_handle_name: [],
        organization_image: [],
        organization_video: [],
        exist_organization_image: [],
        exist_organization_video: [],
        social_media: {
          facebook: null,
          instagram: null,
          twitter: null,
          snapchat: null,
          tiktok: null,
          linkedin: null,
          youtube: null
        }
      },
      preview_images: [],
      preview_videos: [],
      crop_image: [],
      IsOpenImageCrop: false
    }
  },

  /** computed */
  computed: {
    ...mapState('organization', ['createLoading']),
    ...mapState('auth', ['roles']),
    ...mapGetters('auth', ['checkPermissionSlug', 'checkRolesByIds']),
    isEditable() {
      return this.checkPermissionSlug('organization_edit')
    },
    validateForm() {
      return !this.errors.any()
    },
  },

  /** created */
  created() {
    this.disabledTab = this.$route.params.id ? undefined : true
    this.fetchData()
  },

  /** methods */
  methods: {
    ...mapActions('organization', {
      create: 'create',
      update: 'update',
    }),
    ...mapActions('common', {
      getCountries: 'getCountries',
      getStates: 'getStates',
      getCities: 'getCities',
    }),

    addOtherLink() {
      // Ensure that custom_fields is initialized before pushing into it
      // if (!this.custom_link) {
      //   this.$set(this.sarai_form.details[saraiIndex], 'custom_fields', [])
      // }
      this.form.custom_link.push({ title: '', link: '' })
    },
    removeOtherLink(index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete?`,
        accept: () => {
          this.form.custom_link.splice(index, 1)
        },
        acceptText: 'Delete'
      })
    },

    handlePhoneNumberChange(number, phoneObj) {
      this.form.mobile_number = number
    },
    /** On Page Load Data Get and Form Value Set */
    async fetchData() {
      if (this.$route.params.id) {
        await this.$store.dispatch('organization/show', this.$route.params.id).then(async (res) => {
          const data = res.data.data
          console.log(data.organization_image, '')

          /** breadcrumb implement  */
          this.breadcrumb = [
            { title: 'Dashboard', url: '/dashboard' },
            { title: 'Gurudwara', url: '/organization/list' },
            { title: `Edit ${data.name}`, active: true }
          ]

          this.isUpdate = true
          this.form.country = data.country._id
          this.form.state = data.state._id
          this.form.city = data.city._id

          // this.form.country = this.countryID = data.country._id
          this.cityID = data.city._id

          /* form variable */
          this.form.name = data.name
          this.form.address = data.address
          this.form.email = data.email || ''
          this.form.website = data.website
          this.form.mobile_number = data.mobile_number || ''
          this.form.location_link = data.location_link
          this.form.custom_link = data.custom_link || []
          this.form.social_media = {
            facebook: null,
            instagram: null,
            twitter: null,
            snapchat: null,
            tiktok: null,
            linkedin: null,
            youtube: null,
            ...data.social_media // Overwrite with existing data from API
          }
          this.form.other_name = data.other_name
          this.form.youtube_handle_name = data.youtube_handle_name
          this.form.exist_organization_image = data.organization_image || []
          this.form.exist_organization_video = data.organization_video || []

          const companyResult = await this.getCountries({ page: 1, limit: 300000, type: 'dropdown', country_id: data.country._id })
          this.CountryList = companyResult.data

          if (data.country._id) {
            const stateResult = await this.getStates({ country: data.country._id, page: 1, limit: 300000, type: 'dropdown', state_id: data.state._id })
            this.StateList = stateResult.data
            this.stateID = this.form.state = data.state._id
          }

          if (data.state._id) {
            const cityResult = await this.getCities({ state: data.state._id, country: data.country._id, page: 1, limit: 300000, type: 'dropdown', city_id: data.city._id })
            this.CityList = cityResult.data
            this.cityID = this.form.city = data.city._id
          }
        })
      } else {
        const companyResult = await this.getCountries({ page: 1, limit: 300000, type: 'dropdown' })
        this.CountryList = companyResult.data

      }
      this.disabledTab = this.$route.params.id ? undefined : true
    },
    validationRules() {
      if (this.$route.params.id && !this.form.exist_organization_image.length) {
        return 'required'
      }
      if (this.$route.path == '/organization/add') {
        return 'required'
      }
    },

    async nextTab() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      this.activeTab = 1
    },

    async save_changes() {
      if (!(await this.$validator.validate()) || this.openingHourError) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      if (this.form.organization_image.length + this.form.exist_organization_image.length > GURUDWARA_MAX_IMAGES_COUNT) {
        this.$vs.notify({
          title: 'Error',
          text: `A maximum of ${GURUDWARA_MAX_IMAGES_COUNT} images are allowed. Please remove extra images.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      if (this.form.organization_video.length + this.form.exist_organization_video.length > GURUDWARA_MAX_VIDEOS_COUNT) {
        this.$vs.notify({
          title: 'Error',
          text: `A maximum of ${GURUDWARA_MAX_VIDEOS_COUNT} videos are allowed. Please remove extra videos.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        let response
        const data = new FormData()
        for (const key in this.form) {           
          if (typeof this.form[key] === 'object') {
            if (key === 'social_media') {
              for (const platform in this.form.social_media) {
                if (this.form.social_media[platform]) {
                  data.append(`social_media[${platform}]`, this.form.social_media[platform])
                }
              }
            } else if (key === 'custom_link') {
              // Handle custom_link as a separate case
              this.form.custom_link.forEach((item, index) => {
                data.append(`custom_link[${index}][title]`, item.title || '')
                data.append(`custom_link[${index}][link]`, item.link || '')
              })
              continue // Skip the default handling for custom_link
            } else {
              if (this.form[key]) {
                this.form[key].map((item) => {
                  data.append(key == 'organization_image' || key == 'organization_video' ? key : key + '[]', item)
                })
              }
            }
          } else {
            data.append(key, this.form[key])
          }
        }


        if (this.$route.params.id) {
          response = await this.update({
            id: this.$route.params.id,
            data
          })
          this.activeTab = 1
        } else {
          response = await this.create(data)
          this.$router.push(`/organization/${response.data._id}/edit`)
        }

        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    /** State API */
    async fetchStates() {
      if (!this.form.country) return
      const stateResult = await this.getStates({
        country: this.form.country,
        page: 1,
        limit: 300000,
        type: 'dropdown'
      })
      this.StateList = stateResult.data
    },
    /** City API */
    async fetchCities() {
      if (!this.form.state) return
      const cityResult = await this.getCities({
        state: this.form.state,
        country: this.form.country,
        page: 1,
        limit: 300000,
        type: 'dropdown'
      })
      this.CityList = cityResult.data
    },

    /** add data in array */
    addData(type) {
      switch (type) {
      case 'other_name':
        this.form.other_name.push('')
        break
      case 'sarai':
        this.sarai_form.details.push({
          name: '',
          email: '',
          website: '',
          location: '',
          mobile_number: [],
          custom_fields: [] // Add this line
        })
        break
      case 'youtube_handle_name':
        this.form.youtube_handle_name.push('')
        break
      default:
        break
      }
    },

    /** remove data from array */
    removeData(type, index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete?`,
        accept: () => {
          switch (type) {
          case 'other_name':
            this.form.other_name.splice(index, 1)
            break
          case 'sarai':
            this.sarai_form.details.splice(index, 1)
            break
          case 'youtube_handle_name':
            this.form.youtube_handle_name.splice(index, 1)
            break
          default:
            break
          }
        },
        acceptText: 'Delete'
      })
    },

    /** add mobile number for sarai */
    addMobileNumber(saraiIndex) {
      this.sarai_form.details[saraiIndex].mobile_number.push('')
    },

    /** remove mobile number for sarai */
    removeMobileNumber(saraiIndex, mobileIndex) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete?`,
        accept: () => {
          this.sarai_form.details[saraiIndex].mobile_number.splice(mobileIndex, 1)
        },
        acceptText: 'Delete'
      })
    },

    /** navigate to gurudwaraList */
    navigateToGurudwaraList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.$router.push({ name: 'gurudwara-list' })
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },

    /** file upload  */
    handleFileUpload(e) {
      const files = Array.from(e.target.files) // Convert FileList to array

      // Check the total number of images, including existing ones
      const totalImages = files.length + this.preview_images.length + this.form.exist_organization_image.length
      if (totalImages > GURUDWARA_MAX_IMAGES_COUNT) {
        this.$vs.notify({
          title: 'Error',
          text: `You can upload a maximum of ${GURUDWARA_MAX_IMAGES_COUNT} images. Current selection exceeds the limit.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        // e.target.value = '' // Reset input value to allow re-selection
        return
      }

      this.crop_image = [] // user don't crop image and upload cancel to cropper Empty
      // Validate and handle each file
      files.forEach((file) => {
        if (!file) {
          this.$vs.notify({
            title: 'Error',
            text: 'No file selected',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
          // e.target.value = '' // Reset input value to allow re-selection
          return
        }

        if (file.size > MAX_IMAGE_SIZE) {
          // Validate file size (1 MB)
          this.$vs.notify({
            title: 'Error',
            text: `File "${file.name}" exceeds the ${MAX_IMAGE_SIZE / 1024 / 1024}MB size limit.`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
          // e.target.value = '' // Reset input value to allow re-selection
          return
        }

        // Create a preview URL and add it to the array
        // const previewURL = URL.createObjectURL(file);
        // this.preview_images.push({ src: previewURL, file });
        // this.form.organization_image.push(file);

        // Create a blob for cropping
        const blob = URL.createObjectURL(file)

        this.crop_image.push({
          src: blob,
          type: file.type
        })

        // Open cropper popup
        this.IsOpenImageCrop = true

        // Increment fileKey to force re-render
        this.fileKey++
      })
      // e.target.value = '' // Reset input value to allow re-selection
    },

    /** Cropper and Set Images */
    cropImage() {
      this.$refs.cropper.forEach((element, key) => {
        const result = element.getResult()
        if (!result.canvas) {
          this.$vs.notify({
            title: 'Error',
            text: 'Please crop the image before uploading.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
          return
        }

        // Convert cropped image to base64 and validate size
        const resultBase64 = result.canvas.toDataURL(this.crop_image[key].type)
        const base64Image = resultBase64.replace(`data:${this.crop_image[key].type};base64,`, '')
        const blob = this.b64toBlob(base64Image, this.crop_image[key].type, key)

        // Ensure cropped image size is less than 1 MB
        if (blob.size > MAX_IMAGE_SIZE) {
          this.$vs.notify({
            title: 'Error',
            text: `Cropped image exceeds the ${MAX_IMAGE_SIZE / 1024 / 1024}MB size limit.`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
          return
        }

        this.preview_images.push({ src: URL.createObjectURL(blob), blob })
        this.form.organization_image.push(blob)
      })

      this.crop_image = []
      this.IsOpenImageCrop = false
    },

    /** Base 64 */
    async handleVideoUpload(e) {
      const files = Array.from(e.target.files)
      const totalVideos = files.length + this.preview_videos.length + this.form.exist_organization_video.length

      if (totalVideos > GURUDWARA_MAX_VIDEOS_COUNT) {
        this.$vs.notify({
          title: 'Error',
          text: `You can upload a maximum of ${GURUDWARA_MAX_VIDEOS_COUNT} videos.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      for (const file of files) {
        if (!file) continue

        try {
          const duration = await this.getVideoDuration(file)
          if (duration > MAX_VIDEO_DURATION) {
            this.$vs.notify({
              title: 'Error',
              text: `Video "${file.name}" exceeds the ${MAX_VIDEO_DURATION} seconds limit.`,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              position: 'top-center',
              time: 5000,
              color: 'primary'
            })
            continue
          }

          const previewURL = URL.createObjectURL(file)
          this.preview_videos.push({ src: previewURL, file })
          this.form.organization_video.push(file)
        } catch (error) {
          this.$vs.notify({
            title: 'Error',
            text: `Failed to process video "${file.name}".`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        }
      }
      this.fileKey++
    },
    getVideoDuration(file) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        video.preload = 'metadata'
        video.onloadedmetadata = () => {
          window.URL.revokeObjectURL(video.src)
          resolve(video.duration)
        }
        video.onerror = () => {
          reject('Error loading video')
        }
        video.src = URL.createObjectURL(file)
      })
    },
    removeVideo(index, type) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this video?`,
        accept: () => {
          if (type === 'preview') {
            URL.revokeObjectURL(this.preview_videos[index].src)
            this.preview_videos.splice(index, 1)
            this.form.organization_video.splice(index, 1)
          } else {
            const exist_index = this.form.exist_organization_video.findIndex((value) => index === value)
            if (exist_index !== -1) {
              this.form.exist_organization_video.splice(exist_index, 1)
            }
          }
        },
        acceptText: 'Delete'
      })
    },

    b64toBlob(b64Data, contentType = '', key, sliceSize = 512) {
      const byteCharacters = window.atob(b64Data)
      const byteArrays = []
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      const blob = new File(byteArrays, `image_${key}.jpg`, {
        type: contentType
      })
      // this.form.image = blob;
      // this.preview_image = URL.createObjectURL(blob);

      // this.form.organization_image.push(file);

      // this.preview_images.push({ src: URL.createObjectURL(blob), blob })
      // this.form.organization_image.push(blob)

      return blob
    },

    /** remove file */
    removeFile(index, type) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this image?`,
        accept: () => {
          if (type === 'preview') {
            // Revoke the object URL
            URL.revokeObjectURL(this.preview_images[index].src)

            // Remove the file from the arrays
            this.preview_images.splice(index, 1)
            this.form.organization_image.splice(index, 1)
          } else {
            const exist_index = this.form.exist_organization_image.findIndex((value) => index === value)
            if (exist_index !== -1) {
              this.form.exist_organization_image.splice(exist_index, 1)
            }
          }
        },
        acceptText: 'Delete'
      })
    }
  },

  /** watch */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-gurudwara',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-gurudwara > .con-vs-loading')
      }
    },
    'form.country'(newValue) {
      this.form.state = null
      this.form.city = null
      this.StateList = []
      this.CityList = []
      if (newValue) {
        this.fetchStates()
      }
    },
    'form.state'(newValue) {
      this.form.city = null
      this.CityList = []
      if (newValue) {
        this.fetchCities()
      }
    },

    // countryID(newValue) {
    //   this.StateList = []
    //   this.form.state = null
    //   this.stateID = null
    //   if (newValue && newValue.value) {
    //     this.fetchStates()
    //   }
    // },
    // stateID(newValue, oldValue) {
    //   this.CityList = []
    //   this.form.city = null
    //   this.cityID = null
    //   if (newValue && newValue.value) {
    //     this.fetchCities()
    //   }
    // },
    async '$route.params.id' (newId) {
      await this.fetchData()
      this.activeTab = 1
    }
  }
}
</script>

<style>
.cropper-image {
  height: 400px;
  background: #ddd;
}

.color {
  background-image: none !important;
}

.con-slot-tabs {
  overflow-y: auto !important;
  margin-top: 10px;
  height: -webkit-fill-available;
}

.custom-field-entry {
  /* background-color: #ffffff; */
  padding: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.line-vs-tabs {
  height: 4px !important;
}

.ul-tabs.vs-tabs--ul.ul-tabs-fixed {
  height: 40px;
  overflow: auto;
  scrollbar-width: none;
}

.con-vs-card,
.vs-card--content {
  margin-bottom: 0px;
}

.vti__input {
  background: var(--page-bg);
}
</style>
